export default __webpack_public_path__ + "ef664b4f4bcf9894b2e7a0977c2a4d18.png";